import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trophy } from "lucide-react";

const fmt = (v) => typeof v === "number" ? `$${v.toLocaleString()}` : v;

export default function LeaderboardPanel({ leaderboard, hospitalId }) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader><CardTitle className="flex items-center gap-2"><Trophy className="w-5 h-5 text-amber-500" />{t("hospital.leaderboard")}</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader><TableRow>
            <TableHead>#</TableHead><TableHead>{t("common.name")}</TableHead>
            <TableHead>{t("hospital.cumProfit")}</TableHead><TableHead>{t("hospital.valuation")}</TableHead>
            <TableHead>{t("hospital.reputation")}</TableHead><TableHead>{t("hospital.bedOccupancy")}</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {leaderboard.map((e, i) => (
              <TableRow key={e.hospital_id} className={e.hospital_id === hospitalId ? "bg-emerald-50" : i === 0 ? "bg-amber-50/50" : ""}>
                <TableCell className="font-bold">{e.ranking}</TableCell>
                <TableCell className="font-medium">{e.name} {e.hospital_id === hospitalId && <Badge className="ml-1 text-xs">You</Badge>} {e.is_ai && <Badge variant="secondary" className="ml-1 text-xs">AI</Badge>}</TableCell>
                <TableCell className={`font-mono tabular-nums ${e.cumulative_profit >= 0 ? "text-emerald-600" : "text-red-500"}`}>{fmt(e.cumulative_profit)}</TableCell>
                <TableCell className="font-mono tabular-nums">{fmt(e.valuation)}</TableCell>
                <TableCell>{e.reputation}/100</TableCell>
                <TableCell>{e.bed_occupancy}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
